import { toast, type ToastOptions } from 'react-toastify'

const BASE: ToastOptions = {
  position: 'top-right',
  autoClose: 3000,
  closeOnClick: true,
  pauseOnHover: true,
}

export const notify = {
  success: (message: string, options?: ToastOptions) => toast.success(message, { ...BASE, ...options }),
  error: (message: string, options?: ToastOptions) => toast.error(message, { ...BASE, ...options }),
  warning: (message: string, options?: ToastOptions) => toast.warning(message, { ...BASE, ...options }),
  info: (message: string, options?: ToastOptions) => toast.info(message, { ...BASE, ...options }),
}
